document.addEventListener("DOMContentLoaded", () => {
  const pageURL = window.location.href;
  if (pageURL.includes("form_type=customer")) {
    document.querySelector(".newsletter-form").innerHTML +=
      '<p class="newsletter-form__message newsletter-form__message--success form__message" id="Newsletter-success--template--14504171962471__d930c4f2-4898-4bf7-9884-6cc568480a38" tabindex="-1" autofocus=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-success" viewBox="0 0 13 13"><path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"></path><path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"></path><path d="M4.10645 6.7688L6.13766 8.62553" stroke="white"></path></svg> This email is already subscribed</p>';
  }

  if (window.innerWidth >= 750) {
    const collectionFiltersContainer = document.querySelector(".collection-line-container");
    if (collectionFiltersContainer && collectionFiltersContainer.offsetHeight != 82) {
      const mobileFilters = document.querySelector(".collection-filters-filter-all");
      mobileFilters.classList.remove("show-mobile");

      const desktopFilters = document.querySelectorAll(
        ".collection-filters-filter:not(.collection-filters-filter-all)"
      );
      for (let i = 0; i < desktopFilters.length; ++i) {
        desktopFilters[i].classList.add("hidden");
      }
    }
  }
});

$(document).ready(() => {
  $(".read-more-explain").on("click", function () {
    const $this = $(this);
    const readMoreWrap = $(".read-more-wrap");
    const readMoreFull = $(".read-more-full");
    const readMoreDots = $(".read-more-dots");

    if (readMoreFull.hasClass("hidden")) {
      readMoreDots.addClass("hidden");
      readMoreFull.removeClass("hidden");
      $this.text("Read Less");
    } else {
      readMoreFull.addClass("hidden");
      readMoreDots.removeClass("hidden");
      $this.text("Read More");
    }

    return false;
  });

  // Restore previously saved state when the page is revisited
  function restoreState() {
    const state = history.state;
    if (state && state.loadedHtml) {
      // Restore the loaded products
      $(".collection #product-grid").html(state.loadedHtml);
      
      // Restore the "Load More" button
      if (state.nextPage) {
        $(".collection .pagination-load-more a").attr("href", state.nextPage);
      } else {
        $(".collection .pagination-load-more").hide();
      }

      // Restore the scroll position
      $(window).scrollTop(state.scrollPosition);
    }
  }

  // Save the current state before navigating away
  function saveState() {
    const state = {
      loadedHtml: $(".collection #product-grid").html(),
      nextPage: $(".collection .pagination-load-more a").attr("href"),
      scrollPosition: $(window).scrollTop(),
    };
    history.replaceState(state, document.title, window.location.href);
  }

  // Restore state when the page is loaded
  restoreState();

  // Handle the "Load More" button click
  $(".collection .pagination-load-more a").on("click", function (event) {
    event.preventDefault(); // Prevent default link behavior
    
    const nextPage = $(this).attr("href");
    const loading = $(".loading-overlay__spinner", $(this));
    const text = $("span", $(this));

    loading.removeClass("hidden");
    text.addClass("hidden");

    const scrollBeforeLoading = $(window).scrollTop(); // Capture the scroll position before loading new content

    $.get(nextPage, (data) => {
      const html = $(data);
      const productList = $(".collection #product-grid", html).html();
      const getNextPage = $(".collection .pagination-load-more a", html);

      // Append new products
      $(".collection #product-grid").append(productList);

      // Update the "Load More" button href or hide it if no more pages
      const nextPageUrl = getNextPage.attr("href");
      if (getNextPage.length > 0 && nextPageUrl !== "#") {
        $(".collection .pagination-load-more a").attr("href", nextPageUrl);
      } else {
        $(".collection .pagination-load-more").hide();
      }

      // Store the current state in history, including loaded HTML and the scroll position
      saveState();

      // Restore scroll position after loading
      setTimeout(() => {
        $(window).scrollTop(scrollBeforeLoading);
      }, 100); // Adjust delay if necessary

      text.removeClass("hidden");
      loading.addClass("hidden");

      // Additional functions (like color swatches or event bindings)
      colorSwatches();
    });

    return false;
  });

  // Save the current state before navigating away
  window.addEventListener("beforeunload", saveState);

  // Save the state on any internal navigation (e.g., clicking a product link)
  $("a").on("click", function () {
    saveState();
  });


  if ($(".collection").length > 0) {
    const state = history.state;
    if (state && state.loadedHtml) {
        $(".collection #product-grid").html(state.loadedHtml);
        if (state.nextPage) {
            $(".collection .pagination-load-more a").attr("href", state.nextPage);
        } else {
            $(".collection .pagination-load-more").hide();
        }
        $(window).scrollTop(state.scrollPosition);
    }
  }

  let trigger = document.querySelector(".collection [data-pagination-infinitive-scroll]");
  const observer = new IntersectionObserver(
    async (entries) => {
      if (entries[0].isIntersecting) {
        const newUrl = trigger.getAttribute("data-pagination-infinitive-scroll");

        const loading = $(".loading-overlay__spinner", $(trigger));

        loading.removeClass("hidden");

        $.get(newUrl, (data) => {
          const html = $(data);
          const productList = $(".collection #product-grid", html).html();
          const getNextPage = $(".collection [data-pagination-infinitive-scroll]", html);


          $(".collection #product-grid").append(productList);

          const nextPageUrl = getNextPage.attr("data-pagination-infinitive-scroll");

          if (getNextPage.length > 0 && nextPageUrl !== "#") {
            trigger.setAttribute("data-pagination-infinitive-scroll", nextPageUrl);
          } else {
            trigger.remove();
          }

          loading.addClass("hidden");

          colorSwatches();
        });
      }
    },
    { rootMargin: "800px 0px 800px 0px" }
  );
  
  if (trigger) {
    observer.observe(trigger);
  }

  document.addEventListener('gated:disable', function() {
    trigger = document.querySelector(".collection [data-pagination-infinitive-scroll]");

    if ( trigger ) {
      observer.observe(trigger);
    }
  });


  /*$(".collection [data-pagination-infinitive-scroll]").on("click", function () {
    const nextPage = $(this).attr("href");
    const loading = $(".loading-overlay__spinner", $(this));
    const text = $("span", $(this));

    loading.removeClass("hidden");
    text.addClass("hidden");

    $.get(nextPage, (data) => {
      const html = $(data);
      const productList = $(".collection #product-grid", html).html();
      const getNextPage = $(".collection .pagination-load-more a", html);

      $(".collection #product-grid").append(productList);

      const nextPageUrl = getNextPage.attr("href");
      if (getNextPage.length > 0 && nextPageUrl !== "#") {
        $(".collection .pagination-load-more a").attr("href", getNextPage.attr("href"));
      } else {
        $(".collection .pagination-load-more").hide();
      }

      text.removeClass("hidden");
      loading.addClass("hidden");

      colorSwatches();
    });

    return false;
  });*/

  $(".collection-filters-filter-all a").on("click", function () {
    if ($(this).hasClass("active")) {
      $("body").addClass("mobile-filters");
    } else {
      $("body").removeClass("mobile-filters");
    }
  });
  $(".collection-filters-tabs-title a").on("click", () => {
    $(".collection-filters-filter-all a").removeClass("active");
    $(".collection-filters-bar-all").slideUp(250, () => {
      $("body").removeClass("mobile-filters");
    });

    return false;
  });

  $(document).on("click", ".swiper-slide label", function () {
    const $this = $(this);
    const swiperSlide = $this.closest(".swiper-slide");
    const radioButton = $(`input[type="radio"][id="${$this.attr("for")}"]`, swiperSlide);
    radioButton.trigger("click");

    return false;
  });
});

/*document.addEventListener("DOMContentLoaded", () => {
  const CONTAINER_EL = ".collection-container.scroll-offset";
  const CLEAR_EL = "facet-remove a";
  const CLEAR_ALL_EL = ".facets .clear_filters";
  const LS = "anchor:offset";
  const ANCHOR_EL = ".collection-grid-section";
  const container = document.querySelector(CONTAINER_EL);
  const anchor = document.querySelector(ANCHOR_EL);
  let local = localStorage.getItem(LS);

  if (container) {
    // Function to save current scroll position to localStorage
    const saveScrollPosition = function () {
      if (container) {
        localStorage.setItem(LS_SCROLL_POSITION, container.scrollTop);
      }
    };

    // Function to restore the saved scroll position
    const restoreScrollPosition = function () {
      const savedPosition = localStorage.getItem(LS_SCROLL_POSITION);
      if (savedPosition && container) {
        container.scrollTo({
          top: parseInt(savedPosition, 10),
          behavior: "smooth",
        });
      }
    };
    
    // Save scroll position continuously while scrolling
    container.addEventListener("scroll", saveScrollPosition);

    // Restore scroll position when the page loads
    restoreScrollPosition();

    // Also save the position when clicking a specific button or link
    const registerAnchor = function () {
      localStorage.setItem("anchor:offset", "true");
    };
  
    const removeAnchor = function () {
      if (localStorage.getItem("anchor:offset")) {
        localStorage.removeItem("anchor:offset");
      }
    };
  
    // If needed, add other event listeners for specific actions
    container?.addEventListener(
      "click",
      (e) => {
        if (e.target.matches(".facet-remove a") || e.target.matches(".facets .clear_filters")) {
          registerAnchor();
        }
      },
      false
    );
  
    // When restoring the position, remove the anchor flag
    removeAnchor();
  }
});
*/